module.exports = __webpack_public_path__ + "img/boomstam.a53089ca.png";